export default __webpack_public_path__ + "static/swim-dd9221209321df1f050c97255baba843.jpg";